import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";


export class FreespinMultiplicatorView extends PIXI.Container implements StageLayer {

    private mpIndicatorText: PIXI.Text;
    private brokeTheBankWasSet:boolean = false;
    private textStyle:PIXI.TextStyle = new PIXI.TextStyle(
    {
            fill : 0xFFBF00,
            fontFamily : OpenSans.FAMILY,
            wordWrap : false,
            fontWeight : FontWeight.BOLD,
            fontSize : 60
    });

    private missTexts: { burned: PIXI.Text, notFair: PIXI.Text, rigged: PIXI.Text, luckDraw: PIXI.Text } = {
        burned: new PIXI.Text("bUrN3d!"),
        notFair: new PIXI.Text("It's not FAIR :´("),
        rigged: new PIXI.Text("Rigged..."),
        luckDraw: new PIXI.Text("That's the (no) luck of the draw.")
    };

    private animationNames: string [] = ["nowin", "nowin", "nowin", "nowin"];

    private noWinTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
        fill : 0xFFBF00,
        fontFamily : OpenSans.FAMILY,
        wordWrap : true,
        fontWeight : FontWeight.BOLD,
        fontSize : 92,
        align: "center",
        wordWrapWidth: 500
    });
    private missFeatureSpine:PIXI.spine.Spine;

    /*
        Multiplicator is probably obsolete. In any case use this view for no win coin scenario. #91
     */

    constructor() {
        super();

        this.name = "FreespinMultiplicatorView";

        //this.createTotalMpIndicator();
        this.onOrientationChanged();
        this.setupTexts();

        //const tl = gsap.timeline();
        //for(let i = 0; i < 1000; i++) {
            //tl.add(this.getRandomMissAnimation(), "+=1");
        //}
        //gsap.timeline().add(this.getRandomMissAnimation());
    }

    private setupTexts():void {
        this.missFeatureSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("featureMiss"));
        this.missFeatureSpine.position.set(360, 360);
        //console.log("Feature Miss Animations", this.missFeatureSpine.state.data.skeletonData.animations);
        this.missFeatureSpine.visible = false;

        /*const obj = this.missTexts;
        let k: keyof typeof obj;  // Type is "one" | "two" | "three"
        for (k in obj) {
            const text = obj[k];  // OK
            text.style = this.noWinTextStyle;
            text.anchor.set(0.5, 0.5);
            text.width = 400;
            text.height = 400;
            this.addChild(text);
            text.alpha = 0;
            text.visible = false;
            text.scale.set(0.7, 0.7);
        }*/

        this.addChild(this.missFeatureSpine);
        //gsap.timeline({repeat: -1}).add(this.getRandomMissAnimation(), "+=1.0");
    }

    public getRandomMissAnimation():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const rand:number = Math.floor(Math.random() * ((3) + 1));

        tl.add(() => {
            this.missFeatureSpine.visible = true;
        });
        tl.add(this.playSpine(this.animationNames[rand]));
        tl.add(() => {
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_FAIL.next()});
        }, 0);

        return tl;
    }

    private playSpine(strId:string):gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        const trackIndex:number = 0;
        const animation1:PIXI.spine.core.Animation = this.missFeatureSpine.spineData.findAnimation(strId);
        const animationAlpha:number = 1;
        const mixDuration:number = 0;

        tl.add(() => SpineGSAPWrapper.setAnimation(this.missFeatureSpine, trackIndex, animation1, false, animationAlpha, mixDuration));
        tl.add(() => {
            this.missFeatureSpine.visible = false;
        }, animation1.duration);

        return tl;
    }

    private playMiss(strId:string):gsap.core.Timeline {
        const tl:TimelineLite = gsap.timeline();

        switch (strId) {
            case "burned":
                tl.add(this.runTextAnimation(this.missTexts.burned));
                break;
            case "notFair":
                tl.add(this.runTextAnimation(this.missTexts.notFair));
                break;
            case "rigged":
                tl.add(this.runTextAnimation(this.missTexts.rigged));
                break;
            case "luckDraw":
                tl.add(this.runTextAnimation(this.missTexts.luckDraw));
                break;
        }

        return tl;
    }

    private runTextAnimation(textObj:PIXI.Text):gsap.core.Timeline {
        const tl:TimelineLite = gsap.timeline();

        tl.add(() => {
            textObj.alpha = 0;
            textObj.visible = true;
            textObj.scale.set(0.7, 0.7);
        });
        tl.add([
            gsap.to(textObj, 0.1, {
                alpha: 1
            }),
            gsap.to(textObj.scale, 0.3, {
                x: 1,
                y: 1
            })
        ]);
        tl.add(
            gsap.to(textObj, 0.1, {
                alpha: 0
        }), "+=0.5");
        tl.add(() => {
            textObj.visible = false;
            textObj.scale.set(0.7, 0.7);
        });

        return tl;
    }

    private createTotalMpIndicator():void {
        const text:PIXI.Text = new PIXI.Text("", this.textStyle);
        text.position.set(715, 100);
        this.mpIndicatorText = text;
        text.anchor.set(0.5, 0.5);

        //this.addChild(text);
    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {
            //this.mpIndicatorText.position.set(660, 120);
            const obj = this.missTexts;
            let k: keyof typeof obj;  // Type is "one" | "two" | "three"
            for (k in obj) {
                const text = obj[k];  // OK
                text.position.set(360, 360);
            }
        }
        else {
            //this.mpIndicatorText.position.set(670, 100);
            const obj = this.missTexts;
            let k: keyof typeof obj;  // Type is "one" | "two" | "three"
            for (k in obj) {
                const text = obj[k];  // OK
                text.position.set(360, 360);
            }
        }
    }

    public updateMpText(newValue:number):gsap.core.Timeline {
        const tl:TimelineLite = gsap.timeline();

        /*if(DevilsCrossRoad.model.gameData?.brokeTheBank && newValue >= DevilsCrossRoad.model.gameData.totalSpinWinnings) {
            tl.add(TweenMax.fromTo(this.mpIndicatorText.scale, 0.05, {x: 1, y: 1, yoyo: true}, {x: 0.8, y: 0.8}));
            tl.add(() => {
                this.mpIndicatorText.text = "x" + DevilsCrossRoad.model.gameData.totalSpinWinnings;
            });

            this.brokeTheBankWasSet = true;
        }

        if(!this.brokeTheBankWasSet && "x" + newValue != this.mpIndicatorText.text) {
            tl.add(TweenMax.fromTo(this.mpIndicatorText.scale, 0.05, {x: 1, y: 1, yoyo: true}, {x: 0.8, y: 0.8}));
            tl.add(() => {
                this.mpIndicatorText.text = "x" + newValue;
            });
        }*/

        return tl;
    }

    public show(startVal?:number):void {

        if(startVal) {
            this.mpIndicatorText.text = "X" + startVal;
        }

        //this.visible = true;
    }

    public hide():void {

        if(this.mpIndicatorText) {
            this.mpIndicatorText.text = "";
            this.brokeTheBankWasSet = false;
        }

        //this.visible = false;
    }

}